import { Button, InputNumber, Select } from "antd";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";
import { RequestEmptyFieldsBehaviorType } from "types/enums";

const MethodStepSettingFormContent: FC<{
    handleClose: () => void;
    propertyPath: string;
}> = ({ handleClose, propertyPath }) => {
    const { t: tF } = usePaldockTranslation("forms.method-step-setting");
    const { t: tC } = usePaldockTranslation("common");
    const generalFormUtils = useGeneralForm();
    const { control } = generalFormUtils;

    return (
        <>
            <FormItem
                control={control}
                name={`${propertyPath}.empty_fields_behavior`}
                label={tF("fields.empty_fields_behavior.label")}
            >
                <Select placeholder={tF("fields.empty_fields_behavior.placeholder")} allowClear>
                    {Object.values(RequestEmptyFieldsBehaviorType).map((behaviorType) => (
                        <Select.Option value={behaviorType} key={behaviorType}>
                            {behaviorType}
                        </Select.Option>
                    ))}
                </Select>
            </FormItem>

            <FormItem control={control} name={`${propertyPath}.timeout_ms`} label={tF("fields.timeout_ms.label")} required>
                <InputNumber className="w-full" />
            </FormItem>
            <Button onClick={handleClose} style={{ marginLeft: "8px" }}>
                {tC("close")}
            </Button>
        </>
    );
};

export const MethodStepSettingForm: FC<{
    handleClose: () => void;
    propertyPath: string;
}> = ({ handleClose, propertyPath }) => {
    return <MethodStepSettingFormContent handleClose={handleClose} propertyPath={propertyPath} />;
};
